import { useEffect } from 'react';

/**
 * Adds iOS Smart App Banner meta tag to pages that should show it.
 * Import and call this hook in any page component where you want the banner.
 *
 * Note: Don't use on pages that manage their own apple-itunes-app meta tag (like JoinPage)
 */
export function useSmartAppBanner() {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'apple-itunes-app';
    meta.content = 'app-id=6757444421, app-argument=https://getcircles.com';
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);
}
